enum Action {
  CREATE_BULK_REQUEST = 'createBulkRequest',
  GET_BULK_REQUEST = 'getBulkRequest',
  START_POLLING = 'startPolling',
  STOP_POLLING = 'startPolling',
  REMOVE_POLLING = 'removePolling',
}

export default Action;
